import script from "./BusinessHandlingStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessHandlingStatistics.vue?vue&type=script&setup=true&lang=js"

import "./BusinessHandlingStatistics.vue?vue&type=style&index=0&id=5bfdadf7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bfdadf7"]])

export default __exports__